var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-page',{attrs:{"title":"Pelastuskorttitietokanta"}},[_c('v-row',{staticClass:"fill-height"},[_c('v-col',{attrs:{"cols":"12","lg":"10","offset-lg":"1","xl":"8","offset-xl":"2"}},[_c('pelastuskortti-selain')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }